module.exports = __webpack_public_path__ + "static/images/print.1SOE6EV.svg";